export const getError = state => state.integrations.get('error')
export const getIsSubmitting = state => state.integrations.get('isSubmitting')
export const getIsLoaded = state => state.integrations.get('isLoaded')
